import { CreateEditShipmentStop } from "./CreateEditShipmentData";
import { Stop } from "../../../ducks/app/cargo-and-template-shared";

export const mapFormStopToAPIFormat = (p: CreateEditShipmentStop): Stop => {
  const data = {
    ...p,
    temperature: "",
    date: p.date.toFormat("yyyy-MM-dd"),
    openingDate: p.openingDate?.isValid ? p.openingDate.toFormat("yyyy-MM-dd") : null,
    flipKey: "",
    modified: false,
    // Preserve id (existing stops) and provisoryId (new stops) for backend mapping
    ...(p.id && { id: p.id }),
    ...(p.provisoryId && { provisoryId: p.provisoryId }),
  };
  if (data.place?.coord && !data.place.country) {
    data.place = {
      address: "",
      city: "",
      country: "",
      placeName:
        data.place.placeName ||
        `${data.place.coord.lat}, ${data.place.coord.lon}`,
      postcode: "",
      coord: {
        lat: Number(data.place.coord.lat),
        lon: Number(data.place.coord.lon),
      },
    };
  }
  return data;
};
